/**
 * 講師アカウントごとの設定（現状は動画フィードバックの向き補正値のみ）を
 * バックエンドAPI経由で取得・保存するComposable
 */

import { supabase } from '../supabaseClient'

async function getAuthHeaders() {
  const { data: { session } } = await supabase.auth.getSession()
  const token = session?.access_token || ''
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  }
}

function apiBase() {
  return import.meta.env.VITE_API_BASE_URL || 'https://api.otoeigo.com'
}

/**
 * アカウントに保存されている動画向き補正値（0/90/180/270）を取得する
 * 失敗時は例外を投げず0を返す（新しい端末での初期表示をブロックしないため）
 */
export async function getRotationPreference() {
  try {
    const response = await fetch(`${apiBase()}/api/instructor-settings/video-rotation`, {
      method: 'GET',
      headers: await getAuthHeaders()
    })
    const data = await response.json().catch(() => ({}))
    if (!response.ok) {
      console.warn('⚠️ 動画向き補正値の取得に失敗:', data.message)
      return 0
    }
    return data.rotationDeg ?? 0
  } catch (error) {
    console.warn('⚠️ 動画向き補正値の取得エラー:', error)
    return 0
  }
}

/**
 * アカウントの動画向き補正値を上書き保存する（「向きを直す」ボタン操作のたび呼ばれる）
 * バックグラウンドで良い操作なので、失敗してもUIをブロックしない
 * @param {number} rotationDeg
 */
export async function setRotationPreference(rotationDeg) {
  try {
    const response = await fetch(`${apiBase()}/api/instructor-settings/video-rotation`, {
      method: 'POST',
      headers: await getAuthHeaders(),
      body: JSON.stringify({ rotationDeg })
    })
    if (!response.ok) {
      const data = await response.json().catch(() => ({}))
      console.warn('⚠️ 動画向き補正値の保存に失敗:', data.message)
    }
  } catch (error) {
    console.warn('⚠️ 動画向き補正値の保存エラー:', error)
  }
}

export function useInstructorSettings() {
  return {
    getRotationPreference,
    setRotationPreference
  }
}
